import { FetchStatus, Property, PropertyType } from "../../../../base/types";
import { IAsyncBoundProperties, usePropertyDraftText } from "../../../../base/hooks";
import { useEffect, useState } from "react";

import { IHTMLViewProps } from "./IHTMLViewProps";

export const HTMLViewProperties = [
    { id: Property.HTMLContent, name: 'Content', type: PropertyType.String },
]

export const useHTMLViewProperties = (props: IAsyncBoundProperties) => {
    const { status, result: bindings, error } = props;
    const [properties, setProperties] = useState<IHTMLViewProps>()
    const draftText = usePropertyDraftText({bindings, property: Property.Label})

    useEffect(() => {
        if (status !== FetchStatus.Success || !bindings)
            return;

        const content = bindings.getValue<string>(Property.HTMLContent);
        setProperties({ content })
        // eslint-disable-next-line
    }, [bindings, status]);

    return { status, error, bindings, properties, draftText }
}
